import { classes } from '@services/MarppleShop/shared/util';
import anime from 'animejs';
import { $, html, View } from 'rune-ts';
import { CloseIcon } from '../Icon';
import klass from './ButtonClose.module.scss';

export interface ButtonCloseProps {
  type?: 'submit' | 'button' | 'reset';

  /**
   * 초기 `hide` 상태
   */
  hide?: boolean;

  tag?: 'button' | 'span';
  klass?: string;
}

class Button extends View<ButtonCloseProps> {
  override template() {
    const { type, tag } = this.data;
    if (tag === 'span') {
      return html`<span class="${klass.button}"></span> `;
    }

    return html` <button class="${klass.button}" type="${type ?? 'button'}"></button> `;
  }
}

export class ButtonClose extends View<ButtonCloseProps> {
  button: Button;
  hideAnime?: anime.AnimeInstance;

  constructor(data: ButtonCloseProps = {}) {
    super(data);
    this.button = new Button(this.data);
  }

  override template() {
    const { hide } = this.data;

    const klasses = classes({
      [klass.button_close]: true,
      [this.data.klass ?? '']: !!this.data.klass,
    });

    return html`
      <label data-hide="${!!hide}" class="${klasses}">
        ${this.button}
        <span class="${klass.close}">${CloseIcon()}</span>
      </label>
    `;
  }

  show() {
    if (this.hideAnime && !this.hideAnime.paused) {
      this.hideAnime.pause();
    }

    const el = this.element();
    el.style.opacity = '';
    $(el).setAttribute('data-hide', false);
    this.data.hide = false;
  }

  immediateHide() {
    const el = this.element();

    $(el).setAttribute('data-hide', true);
    el.style.opacity = '';
    this.data.hide = true;
  }

  hide() {
    if (this.hideAnime) {
      this.hideAnime.restart();
    }
  }

  protected override onMount() {
    const el = this.element();
    this.hideAnime = anime({
      autoplay: this.data.hide, // 초기 `hide` 상태가 false 이면 lazy 하게 실행함
      targets: el,
      opacity: 0,
      duration: 300,
      easing: 'easeInOutQuad',
      complete: () => {
        $(el).setAttribute('data-hide', true);
        el.style.opacity = '';
        this.data.hide = true;
      },
    });
  }
}
